var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"h-100 px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"h-100 d-flex"},[_c('div',{staticClass:"m-auto fr-center-card"},[_c('bounce-loader',{attrs:{"color":_vm.loadingColor}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ada2866c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OAuthReturn.vue
// module id = null
// module chunks = 